var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('print',{attrs:{"mode":"testPlan","releaseNoteList":_vm.testPlanList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }